import { WSAvatarIconProps } from "@wingspanhq/fe-component-library";
import {
  InvoiceRow,
  InvoiceStatus,
  PayeeReviewStatus,
  PayerApprovalStatus
} from "@wingspanhq/wingspan-api-sdk";

/**
 * v3 `InvoiceRow` counterpart to `buildInvoiceIcon` (v1 `IInvoice`) — kept
 * separate rather than unioning the two, since `InvoiceRow` has no
 * `amountDetails`/`instantPayoutAt` equivalent (the only visual difference:
 * a paid invoice with no `depositedAt` always renders the same
 * `check-double` icon here, instead of v1's rarer single-check variant).
 */
export const buildInvoiceRowIcon = (
  invoice: InvoiceRow
): Omit<WSAvatarIconProps, "type"> =>
  invoice.status === InvoiceStatus.CREATED
    ? {
        icon: "edit",
        colorBackground: "gray50",
        color: "gray500"
      }
    : invoice.payeeReviewStatus === PayeeReviewStatus.DISPUTED
      ? {
          icon: "alert-circle",
          colorBackground: "amber50",
          color: "amber400"
        }
      : invoice.status === InvoiceStatus.OPENED
        ? {
            icon: "check-envelope",
            colorBackground: "blue50",
            color: "blue500",

            ...(invoice.payerApprovalStatus === PayerApprovalStatus.DECLINED
              ? {
                  badge: true,
                  badgeProps: {
                    theme: "red"
                  }
                }
              : {})
          }
        : invoice.status === InvoiceStatus.OVERDUE
          ? {
              icon: "check-envelope",
              colorBackground: "blue50",
              color: "blue500",
              ...(invoice.payerApprovalStatus === PayerApprovalStatus.DECLINED
                ? {
                    badge: true,
                    badgeProps: {
                      theme: "amber"
                    }
                  }
                : {
                    badge: true,
                    badgeProps: {
                      theme: "red"
                    }
                  })
            }
          : invoice.status === InvoiceStatus.PAYMENT_IN_TRANSIT
            ? {
                icon: "check",
                colorBackground: "gray100",
                color: "green500"
              }
            : invoice.status === InvoiceStatus.PAID
              ? {
                  icon: "check-double",
                  colorBackground: "green50",
                  color: "green500"
                }
              : {
                  icon: "edit",
                  colorBackground: "gray50",
                  color: "gray500"
                };
